import { useState } from "react";
import L from "leaflet";

import { usePromiseStatus } from "../Lib/UI/Hooks/usePromiseStatus";
import { IPlaceHistoryService, IPlaceSearchResult } from "../Features/Search/placeSearchTypes";
import { arrayToBounds, arrayToPoint, boundsToArray, pointToArray } from "../Features/MapComponents/geoUtils";


const useLocalStoragePlaceHistoryService = (storeName: string, maxHistoryItems: number,): IPlaceHistoryService => {

    const [items, setItems] = useState<IPlaceSearchResult[]>([]);
    const loadStatus = usePromiseStatus<IPlaceSearchResult[]>();

    const load = (): Promise<IPlaceSearchResult[]> => {

        const current = getFromStorage();
        setItems(current);

        const promise = Promise.resolve(current);
        loadStatus.setPromise(promise);
        return promise;
    }

    const add = (place: IPlaceSearchResult): Promise<void> => {

        let current = getFromStorage();

        current = current.filter(p => p.id !== place.id);   //Remove previous instances of the passed place
        current.unshift(place);                             //Push place to top of the list (most recent)
        current = current.slice(0, maxHistoryItems);        //Truncate older items
        saveToStorage(current);
        
        setItems(current);

        return Promise.resolve();

    }

    const getFromStorage = (): IPlaceSearchResult[] => {
        const rawItem = localStorage.getItem(storeName);
        return !!rawItem ? JSON.parse(rawItem, reviver) : [];
    };

    const saveToStorage = (data: IPlaceSearchResult[]) => {
        localStorage.setItem(storeName, JSON.stringify(data, replacer));
    };

    const reviver = (key: any, value: any): any => {
        if (key === 'centre')
            return arrayToPoint(value);

        if (key === 'boundingBox')
            return arrayToBounds(value);

        return value;
    };

    const replacer = (key: any, value: any): any => {
        if (key === 'centre')
            return pointToArray(value as L.LatLng);

        if (key === 'boundingBox')
            return boundsToArray(value as L.LatLngBounds);

        return value;
    };

    return {
        items,
        load, loadStatus,
        add
    };

}

export default useLocalStoragePlaceHistoryService;